module.exports = __webpack_public_path__ + "static/media/locations.796fbb66.svg";